module.exports = __webpack_public_path__ + "img/stickerscans.6909b627.png";